/**
 * Carte d'équipe de la liste groupée `/equipes` (219:5329, `exiPlan/CarteEquipe`) : nom, rôle
 * en `Tag`, « N membres · N projets », puis « Ouvrir ».
 */

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Tag } from '@exidis/ui/composants';
import { TEAM_ROLE_KEYS } from '../lib/roleLabels.js';
import { BTN_GHOST_SM, CELL_PLANCHE } from '../ui/theme.js';

export function TeamCard({ team, className = '' }) {
  const { t } = useTranslation();
  return (
    <div className={`${CELL_PLANCHE} flex flex-col gap-2 bg-paper p-4 ${className}`.trim()}>
      <span className="ticks" aria-hidden="true" />
      <div className="flex items-start justify-between gap-2">
        <p className="font-semibold text-ink">{team.name}</p>
        <Tag>{t(TEAM_ROLE_KEYS[team.role] ?? team.role)}</Tag>
      </div>
      <p className="text-sm text-ink-soft">
        {/* Deux `<span>` distincts, pas une seule chaîne concaténée : chacun porte son propre
            pluriel i18next (`_one`/`_other`), et les isoler permet de les cibler séparément
            dans les tests sans dépendre du séparateur « · » entre les deux. */}
        <span>{t('teams.card.members', { count: team.memberCount ?? 0 })}</span>
        {' · '}
        <span>{t('teams.card.projects', { count: team.projectCount ?? 0 })}</span>
      </p>
      <Link to={`/equipes/${team.id}`} className={`${BTN_GHOST_SM} mt-auto self-start`}>
        {t('teams.card.open')}
      </Link>
    </div>
  );
}
